/* eslint-disable-next-line  no-unused-vars */
import React, { useState, useEffect, createElement, useContext } from 'react';
import PropTypes from 'prop-types';
import {
    Alert,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    TextField,
    Tooltip
} from '@mui/material';
import { Download, FileUpload } from '@mui/icons-material';
import { SupplierService } from '../firebase/SupplierService';
import { v4 as uuidv4 } from 'uuid';
import { read, utils, writeFileXLSX } from "xlsx";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { MapContext } from '../map/MapContextProvider';

let allowedExtension = ['.xlsx', '.csv'];
let supplierService = null;
let geocoder;
let excelColumnDef;

export default function UploadSupplier(props) {
    const { openDialog, onClickAction } = props;
    const [selectedFile, setSelectedFile] = useState();
    const [fileType, setFileType] = useState();
    const [validationStatus, setValidationStatus] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState('error');
    const [alertMessage, setAlertMessage] = useState('');
    const [excelData, setExcelData] = useState([]);

    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);

    const [loader, setLoader] = useState(false);

    const { setMapData} = useContext(MapContext);


    useEffect(() => {
        if (!supplierService) supplierService = new SupplierService();
        geocoder = new google.maps.Geocoder();

    }, []);

    useEffect(() => {
        if (excelData.length > 0) {
            let cols = [];
            Object.keys(excelData[0]).forEach(item => {
                cols.push({ field: item })
            });
            setColumnDefs(cols);
            setRowData(excelData);
            checkFileColumns(cols);
        }
    }, [excelData]);

    useEffect(() => {
        // let status = validateForm();
        // setValidationStatus(status);
    }, [selectedFile]);

    const checkExtension = (fileName) => {
        let ext = fileName.split('.').pop();

        if (allowedExtension.indexOf('.' + ext) > -1) {
            console.log(ext);
            setFileType(ext);
            return true;
        }

        return false;
    };

    const validateForm = () => {

        if (selectedFile) return true;
        else return false;
    };

    const onChangeFunc = (evt) => {
        const [file] = evt.target.files;
        let fileExt = checkExtension(file.name);
        let message = '';

        if (file && fileExt) {
            if (checkSize(file)) {
                readExcelFile(file);
                setSelectedFile(file);
                let fileInputDOM = document.getElementById("imageLoaderInput");
                fileInputDOM.value = null;
                return;
            } else {
                message = 'Attachment size exceeds the allowable limit ( 10MB )!';
            }
        } else {
            message = 'Unsupported file extension!';
        }

        setSelectedFile(null);
        setAlertSeverity('error');
        setAlertMessage(message);
    };

    const downloadSampleFileHandler = (evt) => {
        let sampleData = [];

        sampleData.push({
            VendorNo: "VN009412",
            City: "TUCSON",
            State: "CA",
            Address: "SYLMAR	Sylmar, Los Angeles, CA, USA"
        });

        sampleData.push({
            VendorNo: "VN007596",
            City: "NORTH HOLLYWOOD",
            State: "CA",
            Address: "North Hollywood, Los Angeles, CA, USA"
        });

        sampleData.push({
            VendorNo: "VN533235",
            City: "NORTH ANDOVER",
            State: "MA",
            Address: "North Andover, MA 01845, USA"
        });

        /* generate worksheet from state */
        const ws = utils.json_to_sheet(sampleData);
        /* create workbook and append worksheet */
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        /* export to XLSX */
        writeFileXLSX(wb, "SampleOEMData.xlsx");
    };

    const onCloseFunc = () => {
        console.log('close');
        onClickAction();
    };

    async function readExcelFile(file) {
        const f = await (file).arrayBuffer();
        const wb = read(f); // parse the array buffer
        const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
        const data = utils.sheet_to_json(ws); // generate objects
        setAlertSeverity('success');
        setAlertMessage(file.name + ' Record Count : ' + data.length);
        setExcelData(data);
    };

    const buttonOkClicked = async () => {
        let obj = {

        };
        saveItemFirebase(obj);

        onClickAction();
    };

    async function saveItemFirebase() {
        setLoader(true);

        let convertedData = [];
        let requestList = excelData.map(async obj => {

            let vendorVal = obj[excelColumnDef["vendor"]];
            let cityVal = obj[excelColumnDef["city"]];
            let stateVal = obj[excelColumnDef["state"]];
            let addressVal = obj[excelColumnDef["address"]];
            let zipVal = obj[excelColumnDef["zipcode"]];
            // [messageList, dataStatus] = checkMissingProperties(item, messageList);
            // if (!dataStatus) return;

            let addressInfo = "";
            if (cityVal && stateVal)
                addressInfo = addressVal + ", " + cityVal + ", " + stateVal;
            else if (addressVal)
                addressInfo = addressVal;
            else if (cityVal)
                addressInfo = cityVal;

            let myPromise;
            myPromise = new Promise((resolve) => {
                return googleGeocode(addressInfo, resolve);
            });



            myPromise.then((gcode) => {
                if (!gcode || !gcode.location) {
                    return;
                }

                let item = {
                    uuid: uuidv4(),
                    vendorNo: vendorVal,
                    city: cityVal,
                    state: stateVal,
                    latitude: gcode.location.lat(),
                    longitude: gcode.location.lng(),
                    address: gcode.address,
                    placeId: gcode.placeId
                }

                if (obj.ZipCode)
                    item.zip = zipVal;
                if (obj.Address)
                    item.address = addressVal;

                console.log(item);
                convertedData.push(item);
                return item;
            })

            return myPromise;
            // 
            // setMapData([...item]);

            // supplierService.addDocument(item);
        });
        Promise.all(requestList).then(() => {
            console.log(convertedData);
            setMapData(convertedData);
            setLoader(false);

        });

    }

    const checkFileColumns = (columns) => {
        let customMessages = [];

        let vendorName = ['vendorname', 'vendor_name', 'vendor', 'vendor_number', 'vendornumber', 'vendor_no', 'vendorno','vendor no'];
        let state = ['state', 'region', 'state_region', 'stateregion'];
        let city = ['city'];
        let address = ['address'];
        let zipcode = ['zipcode', 'zip_code'];

        let controlList = [
            {
                name: "vendor",
                label: "Vendor No",
                list: vendorName,
                status: false,
                column: null,
                stopper: true
            },
            {
                name: "state",
                label: "State",
                list: state,
                status: false,
                column: null,
                stopper: true,
            },
            {
                name: "city",
                label: "City",
                list: city,
                status: false,
                column: null,
                stopper: true
            },
            {
                name: "address",
                label: "Address",
                list: address,
                status: false,
                column: null
            },
            {
                name: "Zip Code",
                label: "zipcode",
                list: zipcode,
                status: false,
                column: null
            }
        ]

        let columnValues = {};
        columns.forEach(col => {
            controlList.forEach(item => {
                if (!item.status) {
                    if (item.list.indexOf(col.field.toLowerCase()) > -1) {
                        item.status = true;
                        item.column = col.field;
                        columnValues[item.name] = col.field;
                    }
                }
            });
        });

        let dataStatus = true;
        let message = controlList.map((item, index) => {
            if (item.stopper && !item.status) {
                dataStatus = false;
                return (
                    <div key={index}>"{item.name}" Not Provided</div>
                );
            }


        });

        if (!dataStatus) {
            setValidationStatus(false);
            setAlertSeverity('error');
            message.push(<div key={controlList.length}>"Please Download and Check The Sample Data"</div>)
            setAlertMessage(message);
        }
        else {
            setValidationStatus(true);
        }
        excelColumnDef = columnValues;
        console.log(excelColumnDef);
    };

    async function googleGeocode(address, resolve) {
        return await geocoder
            .geocode({ address: address, region: 'US' })
            .then((result) => {
                const tmp = result.results[0]

                let ret = {
                    location: tmp.geometry.location,
                    address: tmp.formatted_address,
                    placeId: tmp.place_id
                }

                resolve(ret);
                return (ret);
            })
            .catch((e) => {
                resolve(null);
                console.log('Geocode was not successful for the following reason: ' + e);
                return null;
            });
    }

    const handleEntering = () => { };

    const checkSize = (data) => {
        const memoryLimit = 10;

        const bytes = data.size;
        const sizeMB = (bytes / 1048576).toFixed(2);
        return sizeMB < memoryLimit;
    };


    return (
        <Dialog
            maxWidth="lg"
            TransitionProps={{ onEntering: handleEntering }}
            open={openDialog}
        >
            <DialogTitle>Upload Supplier List</DialogTitle>
            <DialogContent>
                {loader && (
                    <CircularProgress
                        size={48}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',
                            marginLeft: '-12px'
                        }}
                    />
                )}

                <div className="load-file-container">
                    <div>

                        <div className="load-file-buttons">
                            {/* <div className="MuiFormControlLabel-label">
                                {' '}
                                Warning: .xlsx and .csv files are supported{' '}
                            </div> */}
                            <div className="item-file">
                                <Box component="span" sx={{ p: '16px 160px' }}>
                                    <Button component="label" startIcon={<FileUpload />}>
                                        Upload Supplier
                                        <input
                                            id="imageLoaderInput"
                                            hidden
                                            accept={allowedExtension}
                                            multiple={false}
                                            type="file"
                                            onChange={onChangeFunc}
                                        />
                                    </Button>
                                </Box>
                            </div>{' '}
                        </div>
                        {excelData.length > 0 && <div className="ag-theme-alpine" style={{ height: 400 }}>
                            <AgGridReact rowData={rowData}
                                columnDefs={columnDefs} />
                        </div>
                        }
                        <div className="load-file-view">
                            {alertMessage && (
                                <Alert severity={alertSeverity}>{alertMessage}</Alert>
                            )}
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <IconButton onClick={downloadSampleFileHandler}
                    sx={{ position: 'absolute', left: '20px' }} >
                    <Tooltip title="Download Sample File" arrow >
                        <Download />
                    </Tooltip>
                </IconButton>
                <Button onClick={buttonOkClicked} disabled={!validationStatus}>
                    Import Supplier List
                </Button>
                <Button onClick={onCloseFunc}>Cancel</Button>
            </DialogActions>
        </Dialog >
    );
}

UploadSupplier.propTypes = {
    openDialog: PropTypes.bool,
    // setOnclick: PropTypes.object,
    onClickAction: PropTypes.func
    // formValidation: PropTypes.func
};
